// extracted by mini-css-extract-plugin
export var heroTextWrapper = "hero-module--heroTextWrapper--323a7";
export var heroTitle = "hero-module--heroTitle--51c5d";
export var indexHeroText = "hero-module--indexHeroText--9e777";
export var indexHeroWrapper = "hero-module--indexHeroWrapper--f8ee6";